/* eslint-disable camelcase */

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

const en = {
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hello`,
    description: `Please check our docs.`,
    documentation: `Documentation`,
    contact_us: `Contact us`,
    starleader_values: `StarLeader values`,
    update_your_cookies_settings: `Update your cookies settings`,
    cookiePolicy: `Cookie policy`,
    legalNotice: `Legal notice`,
    privacyPolicy: `Privacy policy`,
  },
  menu: {
    Home: `Home`,
    Summary: `Summary`,
    Reviews: `Reviews`,
    Goals: `Goals`,
    Campaigns: `Campaigns`,
    Analytics: `Analytics`,
    Company: `Company`,
    Admin: `Admin`,
  },
  home_page: {
    no_reviews_yet: `No reviews yet. Ask your employees to review you.`,
    step_1: `Manager Self-Review, Employee/Peer Review`,
    step_2: `Set one goal and 3 actions by manager after discussion with N+1 and team ideally`,
    step_3: `Review goal progress`,
    step_4: `End of campaign`,
    welcome_msg: `Hello`,
    welcome_text: `We are here to support you every step of the way. Let's make this journey successful together!`,
    campaign_step: `Step-by-Step campaign guide`,
    no_campaign: `No campaign available. Contact your HR to create one and start reviewing!`,
    click_here: `Click here`,
    create_one: `to create one.`,
    hr_home_page_intro_1: `Nothing to do here for now. Visit`,
    hr_home_page_intro_2: `the analytics page`,
    hr_home_page_intro_3: `for some stats, or`,
    hr_home_page_intro_4: `the campaign page`,
    hr_home_page_intro_5: `to see details of the current campaign`,
  },
  reviews_page: {
    no_self_reviews_yet: `You have no self reviews yet.`,
    no_reviews_yet: `You have no reviews yet.`,
    no_reviews_visible: `Your reviews will be visible at the end of campaign's step review`,
    my_reviews: `My reviews`,
    self_reviews: `Self-Reviews`,
    submitted_reviews: `Submitted Reviews`,
    from_total_reviews: `From total reviews`,
    campaign: `Campaign`,
    days_till_end: `days till end`,
    day_till_end: `day till end`,
    completed: `Completed`,
    ending_soon: `Ending Soon`,
    active: `Active`,
    in_progress: `In Progress`,
    days_total: `days total`,
    day_total: `day total`,
    campaign_timeline: `Campaign Timeline`,
    start: `Start`,
    end: `End`,
    current_status: `Current Status`,
    days_elapsed: `Days Elapsed`,
    total_duration: `Total Duration`,
  },
  survey_summary: {
    self_review: `Self-Review`,
    review: `Review`,
    peer_review: `Peer-Review`,
    manager_review: `Manager-Review`,
    progress_goal_survey: `Goal-Review`,
    recommendation: `Recommandation`,
    trust: `Trust`,
    open_review: `open review`,
    resume_review: `resume review`,
  },
  categories_tooltip: {
    care: `VISION: envisions a desired future and generates excitement by conveying a compelling, shared vision`,
    coach: `COMMUNICATION: communicates well and frequently provides explanations to stakeholders`,
    develop: `DEVELOPMENT: fosters a development culture by encouraging all team members to embrace a growth mindset and taking actions daily to develop themselves and those around them`,
    deliver: `TRUST: influences others by building credibility and positive relationships rather than relying on authority to generate momentum around Shape priorities`,
    lead: `PROBLEM SOLVING: continuous improvement and the use of proven, problem-solving methodologies`,
  },
  reviews_one_pager: {
    manager_reaction: `manager's reaction:`,
    peer_reaction: `peer's reaction:`,
    comment: `comment:`,
    peer_comment: `peer report comments:`,
    manager_comment: `direct report comments:`,
  },
  survey: {
    comment_label: `Add your comment (Mandatory)`,
    comment_tooltip: `Please be constructive and respectfull. Any racisst, sexist, discriminatory or offensive content will be removed. Use the most neutral language possible to maintain anonymity. Upon notification from a third party, we may remove any inappropriate content.`,
    submit: `Submit`,
    start_survey: `Hey! It will take you 10 minutes to complete this survey that is anonymous. Be as authentic and constructive as possible.`,
    survey_end: `Congrats on your participation! Your review is submitted. Let's have a look in the summary`,
    rating1: `Oops, It appears that your manager has room for improvement in this behavior... What action would you recommend to your manager to improve?`,
    rating5: `Wow! Your manager seems to excel in this behavior. It would be great to let your manager know by providing a concrete example. This will surely be appreciated!`,
    click_icon_bellow: `Click on the icon bellow to continue`,
    click_star: `Click on a star rating to continue`,
    add_comment: `Add your comment here (Optional, except for 1 and 5 stars rating)`,
    add_comment_progress_goal: `Add your comment here (optional and anonymous)`,
    submitted: `Thank you! Your feedback has been submitted successfully`,
    progress_goal: `Do you feel this leader has improved in this behavior?`,
    goal_review_title: `Goal Review`,
    peer: `Peer`,
    manager: `Manager`,
    could_not_save_answer: `Could not save answer. Please retry.`,
    please_answer_all_questions: `Please answer all questions before submitting.`,
    submit_failed: `Submit failed. Please retry.`,
    error_id_missing: `Error: SurveyWizard: Patch SurveyResult: ID is missing`,
    you_are_reviewing: `You're reviewing:`,
  },
  discuss_chat: {
    discuss: `Discuss`,
    chat_tooltip: `Open the discussion window. If new message received a notification will be send.`,
    chat_label: `Type your message...`,
  },
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `menu level`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  reviews: `reviews`,
  review: `review`,
  self_review: `self-review compared to your team`,
  campaign: `campaign`,
  me: `Me`,
  other_managers: `Other managers`,
  recommend_you: `Recommend you`,
  trust_you: `Trust you`,
  goalProgressApprovalPercentage: `Goal progress approvals`,
  employee: `collaborateur`,
  manager: `manager`,
  hr: `HR`,
  summary: `Summary`,
  rating_answer: `rating answers`,
  from_your_team: `from your team`,
  from_your_peers: `from your peers`,
  comparaison: `comparaison`,
  no_results_yet: `No results yet.`,
  campaign_page: {
    campaign: `Campaign`,
    set_goal: `Setting goals`,
    review_period: `Reviewing period`,
    one_campaign: `There is already a campaign in progress. Only one campaign can be active at this time.`,
    no_campaign: `There are no campaigns currently.`,
    create_campaign: `Create new campaign`,
    start_campaign: `Start`,
    edit_campaign_dates: `Edit Campaign Dates`,
    edit_step_dates: `Edit Campaign Step Dates`,
    campaign_period: `Campaign Period`,
    save_changes: `Save Changes`,
    cancel: `Cancel`,
    create_new_campaign: `Create New Campaign`,
    select_start_date: `Select a start date for your new campaign. The system will automatically create default dates for all campaign steps.`,
    campaign_start_date: `Campaign Start Date`,
    please_select_date: `Please select a start date`,
    campaign_overlap_error: `Cannot create a new campaign that overlaps with an existing campaign period`,
    access_denied: `Access Denied`,
    hr_admin_only: `This page is only accessible to HR and Admin users.`,
    campaign_overview_tooltip: `Campaign overview - You can edit all dates of the current campaign steps`,
    validation_select_dates: `Please select both start and end dates`,
    validation_start_after_end: `Start date cannot be after end date`,
    validation_step_before_campaign_start: `Campaign step start date cannot be before campaign start date. Please update the campaign period first.`,
    validation_step_after_campaign_end: `Campaign step end date cannot be after campaign end date. Please update the campaign period first.`,
    all_campaigns: `All Campaigns`,
    expand: `Expand`,
    collapse: `Collapse`,
    campaign_name: `Campaign {number}`,
  },
  values_page: {
    title: `Rome was not built in a day but burnt in a night`,
    author: ``,
    section1: `Relation between manager and subordinate is key in our
    professionnal life. Whether you are an employee or a manager,
    it is in everyone's interest to place the quality of this
    relationship at the heart of our daily interactions.`,
    section2: `As a subordinate, StarLeader gives you the opportunity to
    express yourself anonymously and constructively about your
    manager's behaviour. Your opinion matters!`,
    section3: `Become a change agent by helping your manager to become better
    version of himself, that's the unique experience we offer
    you with StarLeader.`,
    section4: ` As a manager, StarLeader is a tool to improve your self
    awareness, progress and develop trust within your team! Become
    a better StarLeader and give yourself more chances to grow
    within the company, this is the unique experience we offer you
    offer you with StarLeader.`,
    section5: `By making leadership quality a new indicator of success,
    StarLeader aims to combine sustainable performance with team
    well-being.`,
  },
  continue: `Continue`,
  privacy_page: {
    title: `Privacy Policy`,
    section1: `At StarLeader, protecting your privacy is a priority.`,
    section2: `When you use the www.starleader.io website (the
      "Site"), we may collect personal data about
      you.`,
    section3: `The purpose of this policy is to inform you about how we
    process such data in compliance with Regulation (EU) 2016/679
    of 27 April 2016 on the protection of individuals with regard
    to the processing of personal data and on the free movement of
    such data (the "GDPR").`,
    section4: `1. Who is the data controller?`,
    section5: `While you are browsing our Website, the data controller is
    Alphayz, a S.A.S company registered in the Nanterre Trade and
    Companies Register under number 952 853 109 and whose
    registered office is located at 33 rue Benoit Malon 92800
    Puteaux ("We")`,
    section6: `On the other hand, when our customers use our services, we
    collect and process personal data on their behalf and for
    their account. Our customers are therefore data controllers in
    accordance with Article 4 of the GDPR. We act as a processor,
    as a service provider.`,
    section7: `2. What data do we collect?`,
    section8: `Personal data is data that can be used to identify an
    individual directly or by cross-checking with other data.`,
    section9: `We collect personal data in the following categories:`,
    section10: `Identification data `,
    section11: `(name, first name, professional email address);`,
    section12: `Data related to your professional life `,
    section13: `(company name, position / function);`,
    section14: `Connection data `,
    section15: `(connection logs, encrypted passwords);`,
    section16: `Browsing data `,
    section17: `(IP address, pages viewed, date and time of connection,
      browser used, operating system, user ID, IFA);`,
    section18: `Location data. `,
    section19: `3. On what legal grounds, for what purposes and for how
    long do we keep your personal data?`,
    section20: `Objectives`,
    section21: `Legal basis`,
    section22: `Shelf life`,
    section23: `To provide our services available on our Site`,
    section24: `Execution of pre-contractual measures taken at your
    request and/or execution of the contract that you or your
    company have signed with Us`,
    section25: `When you have created an account: your data is kept for
    the duration of your account. Your connection logs are
    kept for one (1) year. If your account is inactive for 2
    years, your personal data will be deleted if you do not
    respond to our reactivation email`,
    section26: `Improve our services`,
    section27: `Our legitimate interest in improving our services`,
    section28: `Personal data are kept for one (1) year`,
    section29: `Send newsletters, solicitations and promotional messages`,
    section30: `For customers: our legitimate interest in building
    customer loyalty and keeping customers informed of our
    latest news For prospects: your consent`,
    section31: `The data is kept for 3 years from your last contact with Us`,
    section32: `Respond to your information requests`,
    section33: `Our legitimate interest in responding to your requests`,
    section34: `The data is kept for the time necessary to process your
    request for information and deleted once the request for
    information has been processed`,
    section35: `To draw up statistics (of navigation, of the audience of
      the Site, etc.) and to improve the functionalities of the
      Site through the deposit of cookies of audience
      measurement`,
    section36: `Our legitimate interest in analyzing the composition of
    our customer base and improving our services`,
    section37: `The data is kept for twenty five (25) months`,
    section38: `Manage requests to exercise rights`,
    section39: `Our legitimate interest in responding to your requests and
    keeping track of them`,
    section40: `If we ask you for proof of identity, we will only keep it
    for as long as it takes to verify your identity. Once the
    verification is complete, the proof of identity is
    deleted.`,
    section41: `4. Who are the recipients of your data?`,
    section42: `Will have access to your personal data:`,
    section43: `The staff of our company;`,
    section44: `Our subcontractors: hosting provider, audience
    measurement and analysis provider, e-mail provider;`,
    section45: `If applicable: public and private organizations,
    exclusively to meet our legal obligations;`,
    section46: `5. Will your data be transferred outside the European
    Union?`,
    section47: `Your data is kept and stored for the duration of the treatment
    on the servers of the company Heroku, located in the European
    Union.`,
    section48: `6. What are your rights to your data?`,
    section49: `You have the following rights with respect to your personal
    data:`,
    section50: `Right to information: `,
    section51: `this is precisely the reason why we have drafted this policy.
    This right is provided for in articles 13 and 14 of the RGPD.`,
    section52: `Right of access: `,
    section53: `you have the right to access all your personal data at any
    time, in accordance with Article 15 of the GDPR.`,
    section54: `Right of rectification: `,
    section55: `you have the right to rectify your inaccurate, incomplete or
    outdated personal data at any time in accordance with Article
    16 of the GDPR.`,
    section56: `Right to limitation: `,
    section57: `you have the right to obtain the limitation of the processing
    of your personal data in certain cases defined in Article 18
    of the GDPR.`,
    section58: `Right to erasure: `,
    section59: `you have the right to request that your personal data be
    erased, and to prohibit future collection of your personal
    data on the grounds set out in Article 17 of the GDPR.`,
    section60: `Right to lodge a complaint with a competent supervisory
    authority`,
    section61: `(in France, the CNIL), if you consider that the processing of
    your personal data constitutes a violation of the applicable
    texts, in accordance with Article 77 of the GDPR`,
    section62: `The right to set up instructions for the retention, deletion
    and disclosure of your personal data after your death.`,
    section63: `Right to withdraw your consent at any time: `,
    section64: `for purposes based on consent, Article 7 of the GDPR states
    that you may withdraw your consent at any time. Such
    withdrawal will not affect the lawfulness of the processing
    carried out before the withdrawal.`,
    section65: `Right to portability: `,
    section66: `under certain conditions specified in Article 20 of the GDPR,
    you have the right to receive the personal data you have
    provided to us in a standard machine-readable format and to
    request its transfer to the recipient of your choice.`,
    section67: `Right to object: `,
    section68: `under Article 21 of the GDPR, you have the right to object to
    the processing of your personal data. Note, however, that we
    may continue to process them despite this objection, for
    legitimate reasons or the defense of legal rights.`,
    section69: `You can exercise these rights by writing to us at the address
    below. We may ask you to provide additional information or
    documents to prove your identity.`,
    section70: `7. What cookies do we use?`,
    section71: `To learn more about how we manage cookies we invite you to
    consult our`,
    section72: `8. Contact point to exercise your rights`,
    section73: `Contact email: support@starleader.io.`,
    section74: `Contact address : 33 rue Benoit Malon 92800 Puteaux FRANCE.`,
    section75: `9. Changes`,
    section76: `We may modify this policy at any time, in particular to comply
    with any regulatory, legal, editorial or technical
    developments. These changes will apply as of the effective
    date of the modified version. You are therefore invited to
    regularly consult the latest version of this policy.
    Nevertheless, we will keep you informed of any significant
    changes to this Privacy Policy.`,
    section77: `Effective date: June 06, 2023`,
  },
  cookies_page: {
    title: `Cookie Policy`,
    section1: `1. What is a Cookie?`,
    section2: `During your navigation on the site www.starleader.io, cookies,
    pixels and other tracers are deposited on your browser.`,
    section3: `A cookie is a small file, often encrypted, stored in your
    browser or your terminal and identified by a name. It is
    deposited when you visit a site. Each time you return to the
    site in question, the Cookie is retrieved from your browser or
    terminal. Thus, each time you visit the site, the browser is
    recognized.`,
    section4: `2. Identification of Cookies`,
    section5: `We may use technical and audience measurement Cookies. You
    will be informed of this when you first visit the Site using
    these Cookies. You will then be asked to accept or decline
    them in the manner described below.`,
    section6: `Technical and functional cookies`,
    section7: `Technical and functional cookies are necessary for the proper
    functioning of the Site and to provide you with our services.
    They are used throughout your navigation, in order to
    facilitate it and to execute certain functions.`,
    section8: `A technical Cookie may, for example, be used to remember your
    responses to a form or your preferences regarding language or
    the layout of the Site, where such options are available.`,
    section9: `Cookies for audience measurement`,
    section10: `These cookies, also known as "analytical cookies",
    allow us to measure the number of visits, the number of pages
    viewed and user activity. They may collect your IP address to
    the city from which you are connecting. Cookies for audience
    measurement allow us to generate statistics on the number of
    visits and navigation of our Site in order to improve our
    performance. The cookies used also allow us to identify
    navigation problems and eventually solve them.`,
    section11: `3. Your cookie preferences`,
    section12: `Cookies that can be deposited without consent`,
    section13: `Some cookies do not require your consent, such as:`,
    section14: ` Technical and functional cookies that are necessary
    for the operation of the Site;`,
    section15: ` Certain audience measurement cookies or cookies that
    that allow us to test different versions of the Site for the
    purpose of optimizing editorial choices;`,
    section16: `Acceptance or refusal of Cookies subject to your express
    consent`,
    section17: `All other Cookies require your consent. These are advertising
    cookies, social networking cookies, content personalization
    cookies and some audience measurement cookies. You can freely
    choose to accept or refuse the use of these Cookies.`,
    section18: `You can accept or reject these cookies when you first visit
    the Site.`,
    section19: `Your choices to accept or decline Cookies will be retained for
    a period of six (6) months.`,
    section20: `You are free to withdraw your consent and more generally to
    modify your preferences at any time, via the cookies banner
    link`,
    section21: `Setting up your browser`,
    section22: `It is also possible to set your browser to accept or reject
    certain cookies.`,
    section23: `Each browser offers different configuration methods.`,
  },
  legal_page: {
    title: `Legal Notice`,
    section1: `Publisher:`,
    section2: `The www.starleader.io website is published by: `,
    section3: `The company Alphayz `,
    section4: `S.A.S with a share capital of 5.000,00 euros`,
    section5: `Registered at the Registry of Trade and Companies of Nanterre
    under the number 952 853 109`,
    section6: `Registered office: 33 rue Benoit Malon 92800 Puteaux FRANCE`,
    section7: `Intra-community VAT number: FR88952853109 `,
    section8: `Telephone number: +33 6 64 44 59 06`,
    section9: `Email address: support@starleader.io `,
    section10: `Director of the publication:`,
    section11: `Ms. Laura Goddard, President of the company Alphayz`,
    section12: `Hosting provider:`,
    section13: `Company: Salesforce Sarl (Heroku.Inc is a Salesforce company)`,
    section14: `Registered office: Route de la Longeraie 9, Morges, 1110,
    Switzerland, attn: Director, EMEA Sales Operations, with a
    copy to attn.: Legal Department - Service Juridique, 3 Avenue
    Octave Gréard, 75007 Paris, France.`,
    section15: `The Heroku servers used by starleader.io are situated in the
    European Union.`,
  },
  goals_page: {
    title: `Goals`,
    target: `Target`,
    completed: `Completed`,
    complete: `Complete`,
    todo: `To do`,
    inprogress: `In progress`,
    done: `Done`,
    no_reviews: `There are still no reviews submitted for you. Ask your employees to fill out the survey and check back later.`,
    no_reviews_1: `There are no reviews for you yet. Ask your employees`,
    no_reviews_2: `to review you`,
    no_reviews_3: `and check back. Review scores are important for a constructive goal.`,
    one_goal: `You can create only one goal`,
    create_new_goal: `Create new goal`,
    set_score: `Target Score`,
    pick_rating: `Pick a rating higher than current`,
    pick_score: `Pick a score higher than current`,
    achieve_improvement: `Timeline`,
    one_month: `One month`,
    two_months: `Two months`,
    three_months: `Three months`,
    define_actions: `Define your 3 actions:`,
    pick_action: `Pick an action from the left or type in custom`,
    chose_category: `Choose a category you want to improve in`,
    chose_behavior: `Choose the behavior you want to improve in`,
    category_selection_description: `Select a category to create your development goal and focus your improvement efforts.`,
    rating_label: `Rating`,
    best_performance: `Best Performance`,
    selected: `Selected`,
    categories_ordered_note: `Categories are ordered by your current performance rating.`,
    behavior_selection_description: `Select a behavior to create your development goal and focus your improvement efforts.`,
    behaviors_ordered_note: `Behaviors are ordered by your current performance rating.`,
    no_behaviors_available: `No behaviors available for this category.`,
    configure_goal: `Configure Your Goal`,
    configure_goal_description: `Set your target rating and timeline to complete your development goal.`,
    current_rating: `Current Rating`,
    timeline_description: `Choose how long you want to achieve this improvement.`,
    configuration_note: `Select a target rating higher than your current performance and a realistic timeline.`,
    no_rating_options: `No rating options available`,
    campaign_ends_soon: `Campaign ends soon`,
    actions_description: `Select 3 actions to help you achieve your goal. You can choose from suggested actions or create your own.`,
    actions_progress: `Actions`,
    selected_actions: `Selected Actions`,
    action: `Action`,
    available_actions: `Available Actions`,
    suggested: `Suggested`,
    custom: `Custom`,
    recommended: `Recommended`,
    or_create_custom: `OR`,
    custom_action_placeholder: `Write your own action to help achieve this goal...`,
    add_custom_action: `Add Custom Action`,
    create_goal: `Create Goal`,
    actions_note: `You can edit or remove actions until you submit. Once submitted, you can track your progress.`,
    pick_existing_actions: `Pick Existing Actions`,
    pick_existing_description: `Choose from our suggested actions to help you achieve your goal.`,
    write_custom_actions: `Write Custom Actions`,
    write_custom_description: `Create your own personalized actions to support your development.`,
    no_actions_selected: `No actions selected yet. Choose from existing actions or write your own.`,
    progress: `Set A Goal`,
    category: `Category`,
    objective: `Objective`,
    score: `Score`,
    timeline: `Timeline`,
    actions: `Actions`,
    actions_complete: `Actions completed`,
    status: `Status`,
    ready_to_complete: `Ready to Complete`,
    in_progress: `In Progress`,
    complete_goal: `Complete Goal`,
    close_goal: `Close Goal`,
    read_more: `Read More`,
    edit: `Edit`,
    received_reviews: `Received Reviews`,
    submitted_reviews: `Submitted Reviews`,
    peer_review: `Peer Review`,
    peer_reviews: `Peer Reviews`,
    manager_review: `Manager Review`,
    manager_reviews: `Manager Reviews`,
    self_review: `Self Review`,
    overall_progress: `Overall Progress`,
    completion_rate: `Completion Rate`,
    total_reviews: `Total Reviews`,
    campaign_step_status: `Campaign Step Status`,
    campaign_dates: `Campaign Dates`,
    remaining_days: `Remaining Days`,
    days_left: `days left`,
    overall_participation: `Overall Participation`,
    reviews_received: `reviews received`,
    review_data_available_soon: `Review data will be available when 80% of expected reviews are received or 2 days before campaign end`,
    days_till_end: `days till end`,
    review_campaign_step: `review campaign step`,
    campaign_timeline: `Campaign Timeline`,
    start: `Start`,
    end: `End`,
    current_status: `Current Status`,
    days_elapsed: `Days Elapsed`,
    total_duration: `Total Duration`,
    ending_soon: `Ending Soon`,
    active: `Active`,
    campaign_completed: `Completed`,
    days_total: `days total`,
    from_total_reviews: `From total reviews`,
  },
  ratingDescription: {
    1: `Strongly disagree`,
    2: `Disagree`,
    3: `Neutral`,
    4: `Agree`,
    5: `Strongly agree`,
  },
  reactions: {
    1: `Thank you`,
    2: `Love it`,
    3: `Disagree`,
  },
  tasks: {
    your_tasks: `Open Tasks`,
    select_feedback_team: `Select Feedback Team`,
    select_feedback_team_description: `Choose who gives feedback to your direct reports.`,
    no_reviewers_selected: `No reviewers selected yet`,
    select_reviewers_description: `Click the "Select" button to choose reviewers for your team members.`,
    select: `Select`,
    review_your_manager: `Review Your Manager`,
    review_your_manager_description: `Provide upward feedback to your manager.`,
    review_your_peers: `Review Your Peers`,
    review_your_peers_description: `Give feedback to your peers as requested.`,
    self_review: `Self Review`,
    self_review_description: `Reflect and submit your self-review.`,
    react_to_received_reviews: `React to Received Reviews`,
    react_to_received_reviews_description: `Mark received feedback with a quick reaction.`,
    react: `React`,
    react_guidance: `Acknowledge feedback to show you've read and appreciated the input.`,
    set_a_goal: `Set a Goal`,
    set_a_goal_description: `Define a goal based on received feedback.`,
    set_goal: `Set Goal`,
    review_goal_progress: `Review Goal Progress`,
    give_feedback: `Give Feedback`,
    check_your_progress: `Check Your Progress`,
    view_detailed_report: `View Detailed Report`,
    check_progress_guidance: `Click to view your detailed progress report in the Summary page.`,
    request_support: `Request Support`,
    request_support_description: `Reach out to your manager, local HR or champion to clarify the results and next steps.`,
    request_support_guidance: `Get help from your selected contacts to understand your feedback and plan your development.`,
    your_support_requests: `Your Support Requests`,
    created_on: `Created on:`,
    completed: `Completed`,
    open: `Open`,
    request_support_dialog_title: `Request Support`,
    request_support_dialog_tooltip: `Explain your situation or what support you need. The selected contacts will receive an email.`,
    explain_your_request: `Explain Your Request`,
    add_request_placeholder: `Add request here...`,
    select_support_contacts: `Manage support contacts (add, remove, or modify)`,
    manager_n1: `Manager N+1`,
    local_hr: `Local HR`,
    click_to_select_champion: `Click to select a new champion`,
    search_user_placeholder: `Search user...`,
    add_your_manager: `Add your Manager N+1`,
    add_your_local_hr: `Add your Local HR`,
    you_dont_have_manager: `You don't have a Manager N+1 assigned in the system.`,
    you_dont_have_local_hr: `You don't have a Local HR assigned in the system.`,
    champion_conflict_error: `Your associated champion cannot be the same as Manager N+1 or Local HR. Please click in the text field to choose someone else.`,
    submit: `Submit`,
    cancel: `Cancel`,
    support_request_sent_success: `Support request sent successfully 🎉`,
    support_request_send_failed: `Failed to send support request. Please try again.`,
  },
  campaign_guide: {
    title: `Overview`,
    feedback_provider: `feedback provider`,
    feedback_receiver: `feedback receiver`,
    feedback_provider_receiver: `feedback provider & receiver`,
    step_of: `Step {current} of {total}`,
    active: `ACTIVE`,
    closed: `CLOSED`,
    date_range: `From {start} to {end}`,
    step_titles: {
      select_reviewers_manager: `Step 1: Select Feedback Team`,
      select_reviewers_employee: `Step 1: Feedback Team`,
      review_manager_employee: `Step 2: Give and Receive Feedback`,
      review_manager: `Step 2: Give and Receive Feedback`,
      review_employee: `Step 2: Give Feedback`,
      goal_manager: `Step 3: Set Goal with action items`,
      goal_employee: `Step 3: Review goals`,
      goal_progress_manager_employee: `Step 4: Review and Give Progress Feedback`,
      goal_progress_manager: `Step 4: Review Progress`,
      goal_progress_employee: `Step 4: Give Progress Feedback`,
      default: `Campaign Phase`,
    },
    step_descriptions: {
      select_reviewers_manager: `As a manager, select the team members who will provide feedback to your direct reports.`,
      select_reviewers_employee: `You may be selected as a feedback provider by one of your managers or peers.`,
      review_manager_employee: `Complete your self-review, give feedback to others, and review received feedback.`,
      review_manager: `Complete your self-review and review received feedback.`,
      review_employee: `Provide feedback for your manager or peers if requested.`,
      goal_manager: `Set a development goal based on the received feedback.`,
      goal_employee: `Support your manager by reviewing their goal and action items.`,
      goal_progress_manager: `Reflect on your progress and update your feedback team with new insights.`,
      goal_progress_employee: `Click to select the leader and provide feedback`,
      default: `Details of this phase will appear here.`,
    },
  },
  select_reviewers: {
    title: `Define the feedback providers for`,
    instruction: `You can select up to 10 feedback providers from the database (min 5 are required)`,
    guidance_title: `🧠 Why 360° Feedback Matters`,
    guidance_1: `The feedback is confidential and anonymous.`,
    guidance_2: `Mix direct reports and peers for a broader perspective.`,
    guidance_3: `The goal is development, not evaluation.`,
    guidance_4: `This helps leaders see how others perceive them — and grow.`,
    guidance_tooltip: `Click for more info on the value of 360° feedback`,
    search_placeholder: `Click to search for an existing user`,
    submit_success: `Feedback team for {{name}} submitted successfully!`,
    submit_error: `Feedback team for {{name}} submission failed. Try again!`,
    too_many_selected: `⚠️ This user has selected {{count}} feedback providers. Please remove {{excess}}!`,
    too_few_selected: `⚠️ Only {{count}} feedback providers selected. Please select at least {{needed}} more!`,
    count_selected: `Selected {{count}} feedback providers`,
  },
  user_card: {
    select_team: `Select Team`,
  },
  tooltips: {
    campaign_guide_info: `Guide for each campaign step based on the user type.`,
    feedback_attention: `You have feedback that needs your attention.`,
    email_notification: `After submitting your request, your selected contacts will receive an email notification.`,
    support_request: `Explain your situation or what support you need. The selected contacts will receive an email.`,
    feedback_360_info: `Click for more info on the value of 360° feedback`,
    self_review: `Self-review`,
    settings: `Settings`,
    reset: `Reset`,
    stretch_info: `Only available at large resolutions > 1600px (xl)`,
  },
  buttons: {
    save_changes: `Save Changes`,
    create_user: `Create User`,
    delete: `Delete`,
    deleting: `Deleting...`,
    cancel: `Cancel`,
    follow: `Follow`,
    followed: `Followed`,
    login: `Login`,
    verify: `Verify`,
    reset_password: `Reset Password`,
    forgot_password: `Forgot password?`,
    sign_in: `Sign in to Minimal`,
    manage_job: `Manage the job more effectively with Minimal`,
    create_account: `Create account`,
    send_request: `Send Request`,
    update_password: `Update Password`,
    return_to_sign_in: `Return to sign in`,
    export_to_pdf: `+ Export to PDF`,
    continue: `Continue`,
    view_detailed_report: `+ View detailed report`,
    view_ai_summary: `View AI Summary`,
    logout: `Logout`,
    submit: `Submit`,
    finish: `Finish`,
    next: `Next`,
    back: `Back`,
    read_more: `Read more`,
    read_less: `Read less`,
    suggested: `Suggested`,
    no_manager_or_peer: `No Manager or Peer`,
  },
  forms: {
    public_profile: `Public Profile`,
    name: `Name`,
    full_name: `Full Name`,
    email_address: `Email Address`,
    phone_number: `Phone Number`,
    address: `Address`,
    country: `Country`,
    state_region: `State/Region`,
    city: `City`,
    zip_code: `Zip/Code`,
    about: `About`,
    company: `Company`,
    role: `Role`,
    first_name: `First name`,
    last_name: `Last name`,
    password: `Password`,
    old_password: `Old Password`,
    new_password: `New Password`,
    confirm_password: `Confirm Password`,
    confirm_new_password: `Confirm New Password`,
    email: `Email`,
    confirm_new_password_label: `Confirm New Password`,
  },
  validation: {
    name_required: `Name is required`,
    email_required: `Email is required`,
    email_invalid: `Email must be a valid email address`,
    phone_required: `Phone number is required`,
    country_required: `Country is required`,
    address_required: `Address is required`,
    state_required: `State is required`,
    city_required: `City is required`,
    zip_required: `Zip code is required`,
    about_required: `About is required`,
    company_required: `Company is required`,
    role_required: `Role is required`,
    avatar_required: `Avatar is required`,
    password_required: `Password is required`,
    old_password_required: `Old Password is required`,
    new_password_required: `New Password is required`,
    confirm_password_required: `Confirm password is required`,
    passwords_match: `Passwords must match`,
    password_min_length: `Password must be at least 6 characters`,
    password_number: `Password must include at least one number`,
    password_special: `Password must include at least one special character`,
    first_name_required: `First name required`,
    last_name_required: `Last name required`,
    code_required: `Code is required`,
  },
  auth: {
    sign_in: `Sign in`,
    please_check_email: `Please check your email!`,
    email_confirmation_code: `We have emailed a 6-digit confirmation code to acb@domain, please enter the code in below box to verify your email.`,
    password_requirements: `Password must contain:`,
    password_requirement_1: `At least 6 characters`,
    password_requirement_2: `Includes a number (0–9)`,
    password_requirement_3: `Includes a special character (e.g. [!@#$%^&*(),.?":{}|<>])`,
    change_password_success: `Change password success!`,
    verify_success: `Verify success!`,
    forgot_password_title: `Forgot your password?`,
    forgot_password_description: `Please enter the email address associated with your account and We will email you a link to reset your password.`,
    return_to_sign_in: `Return to sign in`,
  },
  admin: {
    users: `Users`,
    organizational_chart: `Organizational chart`,
    maintenance: `Maintenance`,
    workspace: `Workspace`,
    campaign: `Campaign`,
    campaign_details: `📊 Campaign Details`,
    id: `🆔 ID`,
    start: `📅 Start`,
    end: `📅 End`,
    steps: `🧩 Steps`,
    users_loaded: `Users loaded`,
    clean_up_topics: `Clean up Topics`,
    survey_results: `📋 Survey Results`,
    reopen_incomplete_surveys: `Reopen Incomplete Surveys`,
    all: `All`,
    incomplete: `Incomplete`,
    not_submitted: `Not Submitted`,
    maintenance_function_performed: `Maintenance function performed`,
    incomplete_surveys_reopened: `incomplete survey(s) reopened`,
    failed_to_reopen_surveys: `Failed to reopen surveys`,
    send_welcome_email: `Send Welcome Email`,
    send: `Send`,
    full_name: `Full name`,
    managers: `Managers`,
    peers: `Peers`,
    local_hr: `Local HR`,
  },
  orgchart: {
    title: `Organization Chart`,
    search_placeholder: `Search user by name...`,
    workspace: `Workspace`,
    legend: `Legend:`,
    direct_reports: `Direct Reports`,
    peers: `Peers`,
    top_level: `Top Level`,
    users: `users`,
    no_users_found: `No users found`,
    employee: `Employee`,
    hr: `HR`,
    admin: `Admin`,
    manager: `Manager`,
    peer: `Peer`,
    showing_user_and_team: `Showing:`,
    and_their_team: `and their team`,
    no_users_in_workspace: `No users found in this workspace.`,
    select_workspace: `Please select a workspace to view the org chart.`,
    no_match_found: `No user found matching your search.`,
  },
  messages: {
    update_success: `Update success!`,
    verify_success: `Verify success!`,
    delete_confirm: `Are you sure want to delete?`,
    no_data: `No Data`,
    survey_result_locked: `🔒 Survey Result Locked`,
    survey_result_locked_description: `The survey results will become available once the Review step of the campaign has ended.`,
    unable_to_logout: `Unable to logout!`,
  },
  ui: {
    empty_content_alt: `empty content`,
    champion: `Champion`,
    date_created: `Date created`,
  },
  hr_analytics: {
    general_analytics: `General Analytics`,
    accounts: `accounts`,
    reviews: `reviews`,
    direct_reviews: `direct reviews`,
    peer_reviews: `peer reviews`,
    self_reviews: `self reviews`,
    set_goal: `set goal`,
    completed_goal: `completed goal`,
    reviewer_selection_overview: `Reviewer Selection Overview`,
    update_teams: `Update Teams`,
      delete_selections: `Delete Selections`,
      delete_selections_tooltip: `Delete all reviewer selections for the selected campaign. This action cannot be undone!`,
      delete_selections_confirm_title: `Confirm Selections Deletion`,
      delete_selections_confirm_message: `Are you sure you want to delete ALL reviewer selections for this campaign? This action is IRREVERSIBLE and will permanently remove all selection data.`,
      delete_selections_success: `Reviewer selections deleted successfully!`,
      delete_selections_error: `Failed to delete reviewer selections. Please try again.`,
      delete_reviews: `Delete Reviews`,
      delete_reviews_tooltip: `Delete all survey results, answers, discussions, and comments for the selected campaign. This action cannot be undone!`,
      delete_reviews_confirm_title: `Confirm Reviews Deletion`,
      delete_reviews_confirm_message: `Are you sure you want to delete ALL survey results, answers, discussions, and comments for this campaign? This action is IRREVERSIBLE and will permanently remove all data.`,
      delete_reviews_success: `Reviews deleted successfully!`,
      delete_reviews_error: `Failed to delete reviews. Please try again.`,
      delete_goals: `Delete Goals`,
      delete_goals_tooltip: `Delete all goals and objectives for the selected campaign workspace. This action cannot be undone!`,
      delete_goals_confirm_title: `Confirm Goals Deletion`,
      delete_goals_confirm_message: `Are you sure you want to delete ALL goals and objectives for this campaign workspace? This action is IRREVERSIBLE and will permanently remove all data.`,
      delete_goals_success: `Goals deleted successfully!`,
      delete_goals_error: `Failed to delete goals. Please try again.`,
      generate_demo_data: `Generate Demo Data`,
      generate_demo_data_tooltip: `Generate completed survey results with positive ratings for up to 8 managers. Includes direct reports and peer reviews.`,
      generate_demo_confirm_title: `Generate Demo Data?`,
      generate_demo_confirm_message: `This will create completed survey results with positive ratings (3-5) and positive trust/recommendation scores for up to 8 active managers in this workspace. Continue?`,
      generate_demo_success: `Demo data generated successfully! Created {surveyResults} survey results with {answers} answers for {managers} managers.`,
      generate_demo_error: `Failed to generate demo data. Please try again.`,
      generating: `Generating...`,
    managers_submitted_selections: `{submitted} out of {total} managers have submitted reviewer selections.`,
    search_manager_by_name: `Search manager by name`,
    submitted: `Submitted`,
    status: `Status`,
    all_submitted: `✅ All Submitted`,
    partially_submitted: `⚠️ Partially Submitted`,
    no_submission: `❌ No Submission`,
    database_updated_successfully: `Database of managers and peers is updated successfully`,
    failed_to_update_reviewer_setup: `Failed to update reviewer setup`,
    managers_reviews: `Managers - Reviews`,
    managers_reached_completion: `{completed} of {total} managers reached 80% reviews completion`,
    rank: `rank`,
    manager: `Manager`,
    percent_total_reviews: `% Total reviews`,
    peer_reviews_ratio: `Peer reviews ratio`,
    direct_reviews_ratio: `Direct reviews ratio`,
    expand: `Expand`,
    ratings: `Ratings`,
    rating: `Rating`,
    trust: `Trust`,
    recommend: `Recommend`,
    reviewers: `Reviewers`,
    no_reviewers_assigned: `No reviewers assigned.`,
    managers_goals: `Managers - Goals`,
    managers_set_goal: `{set} out of {total} managers have set a goal.`,
    goal_set: `Goal set`,
    percent_goal_progress: `% Goal progress`,
    total_votes: `Total votes`,
    peer_votes_ratio: `Peer votes ratio`,
    direct_votes_ratio: `Direct votes ratio`,
    rating_label: `🎯 Rating`,
    due_label: `📅 Due`,
    completed_on: `✅ Completed on`,
    not_completed: `🕓 Not completed`,
    actions: `Actions`,
    no_goals_available: `No goals available.`,
    support_requests_overview: `Support Requests Overview`,
    total: `Total`,
    solved: `Solved`,
    open: `Open`,
    search_requester_by_name: `Search requester by name`,
    status_header: `Status`,
    requester: `Requester`,
    date: `Date`,
    comment: `Comment`,
    manager_header: `Manager`,
    local_hr: `Local HR`,
    champion: `Champion`,
    solved_date: `Solved Date`,
    solved_status: `Solved`,
    open_status: `Open`,
  },
  settings: {
    mode: `Mode`,
    contrast: `Contrast`,
    direction: `Direction`,
    layout: `Layout`,
    stretch: `Stretch`,
    presets: `Presets`,
  },
  profile_sections: {
    social: `Social`,
    about: `About`,
  },
  notifications: {
    activity_comments: `Email me when someone comments on my article`,
    activity_answers: `Email me when someone answers on my form`,
    activity_follows: `Email me when someone follows me`,
    application_news: `News and announcements`,
    application_product: `Weekly product updates`,
    application_blog: `Weekly blog digest`,
  },
  categories: {
    vision: `VISION: envisions a desired future and generates excitement by conveying a compelling, shared vision`,
    communication: `COMMUNICATION: communicates well and frequently provides explanations to stakeholders`,
    development: `DEVELOPMENT: fosters a development culture by encouraging all team members to embrace a growth mindset and taking actions daily to develop themselves and those around them`,
    trust: `TRUST: influences others by building credibility and positive relationships rather than relying on authority to generate momentum around Shape priorities`,
    problem_solving: `PROBLEM SOLVING: continuous improvement and the use of proven, problem-solving methodologies`,
    care: `CARE: ability of my manager to pay attention to me`,
    coach: `COACH: ability of my manager to support me in implementing appropriate solutions`,
    develop: `DEVELOP: ability of my manager to reveal my full potential`,
    deliver: `DELIVER: ability of my manager to guide me in achieving my objectives`,
    lead: `LEAD: ability of my manager to inspire me`,
  },
  campaign_progress: {
    title: "Campaign Progress",
    overall_progress: "Overall Progress",
    task_progress: "Task Progress",
    completed: "Completed",
    in_progress: "In Progress",
    detailed_progress: "Detailed Progress",
    not_active: "Not Active",
    progress_summary: "Status",
    tasks_completed: "tasks done",
  },
    task_history: {
      title: "Task History",
      completed_tasks: "Completed Tasks",
      in_progress_tasks: "In Progress Tasks",
      completed: "Completed",
      in_progress: "In Progress",
      summary: "Track your campaign progress and completed tasks",
      recent_activity: "Recent Activity",
    },
  detailed_report: {
    global_score: `Global Score`,
    direct_reports: `Direct Reports`,
    peer_reports: `Peer Reports`,
  },
};

export default en;
